import { LegalLayout, Section } from "@/components/LegalLayout";
import { CONTACT } from "@/lib/site-data";

export default function ImpressumPage() {
  return (
    <LegalLayout title="Impressum" testid="impressum-page">
      <Section title="Angaben gemäß § 5 TMG">
        <p>Ringel Fenstertechnik – Inhaber Andreas Ringel</p>
        <p>Ostkamp 50 · 59174 Kamen</p>
      </Section>
      <Section title="Kontakt">
        <p>Telefon: {CONTACT.phone}</p>
        <p>E-Mail: {CONTACT.email}</p>
      </Section>
      <Section title="Vertretungsberechtigt">
        <p>Inhaber: Andreas Ringel</p>
      </Section>
      <Section title="Registereintrag">
        <p>Handwerksrolle: [Kammer und Registernummer eintragen]</p>
        <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: [USt-IdNr. eintragen]</p>
      </Section>
      <Section title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
        <p>[Name und Anschrift eintragen]</p>
      </Section>
    </LegalLayout>
  );
}
